@if (style === 'calendar' && type !== 'year') {
  <div>
    @if (!isRange) {
      <div class="igo-col igo-col-100 igo-col-100-m">
        <mat-form-field>
          <mat-datetimepicker-toggle
            class="time-filter-mat-datetimepicker-toggle"
            [for]="datetimePicker"
            matSuffix
          />
          <mat-datetimepicker
            #datetimePicker
            [type]="type"
            [openOnFocus]="true"
            [timeInterval]="5"
          />
          <input
            matInput
            autocomplete="false"
            placeholder="{{ 'igo.geo.timeFilter.date' | translate }}"
            [matDatetimepicker]="datetimePicker"
            [(ngModel)]="date"
            [min]="min"
            [max]="max"
            readonly="readonly"
            (dateChange)="handleDateChange()"
          />
        </mat-form-field>
      </div>
    }
    @if (isRange) {
      <div>
        <div class="igo-col igo-col-100">
          <mat-form-field>
            <mat-datetimepicker-toggle
              class="time-filter-mat-datetimepicker-toggle"
              [for]="minDatetimePicker"
              matSuffix
            />
            <mat-datetimepicker
              #minDatetimePicker
              [type]="type"
              [openOnFocus]="true"
              [timeInterval]="5"
            />
            <input
              matInput
              autocomplete="false"
              placeholder="{{ 'igo.geo.timeFilter.startDate' | translate }}"
              [matDatetimepicker]="minDatetimePicker"
              [(ngModel)]="startDate"
              [min]="min"
              [max]="getRangeMaxDate()"
              readonly="readonly"
              (input)="(startDate)"
              (dateChange)="handleDateChange()"
            />
          </mat-form-field>
        </div>
        <div class="igo-col igo-col-100">
          <mat-form-field>
            <mat-datetimepicker-toggle
              class="time-filter-mat-datetimepicker-toggle"
              [for]="maxDatetimePicker"
              matSuffix
            />
            <mat-datetimepicker
              #maxDatetimePicker
              [type]="type"
              [openOnFocus]="true"
              [timeInterval]="5"
            />
            <input
              matInput
              autocomplete="false"
              placeholder="{{ 'igo.geo.timeFilter.endDate' | translate }}"
              [matDatetimepicker]="maxDatetimePicker"
              [(ngModel)]="endDate"
              [min]="getRangeMinDate()"
              [max]="max"
              readonly="readonly"
              (dateChange)="handleDateChange()"
            />
          </mat-form-field>
        </div>
      </div>
    }
  </div>
}

@if (style === 'calendar' && type === 'year') {
  <div>
    @if (!isRange) {
      <div class="igo-col igo-col-100 igo-col-100-m">
        <mat-form-field>
          <mat-select
            placeholder="{{ 'igo.geo.timeFilter.date' | translate }}"
            [(ngModel)]="year"
            (selectionChange)="handleYearChange()"
          >
            @for (year of listYears; track year) {
              <mat-option [value]="year">{{ year }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (isRange) {
      <div>
        <div class="igo-col igo-col-100">
          <mat-form-field>
            <mat-select
              placeholder="{{ 'igo.geo.timeFilter.startDate' | translate }}"
              [(ngModel)]="startYear"
              (selectionChange)="handleYearChange()"
            >
              @for (startYear of startListYears; track startYear) {
                <mat-option [value]="startYear">{{ startYear }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="igo-col igo-col-100">
          <mat-form-field>
            <mat-select
              placeholder="{{ 'igo.geo.timeFilter.endDate' | translate }}"
              [(ngModel)]="endYear"
              (selectionChange)="handleYearChange()"
            >
              @for (endYear of endListYears; track endYear) {
                <mat-option [value]="endYear">{{ endYear }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }
  </div>
}

<br />
@if (!isRange && style === 'slider' && type === 'year') {
  <div class="igo-col igo-col-100 igo-col-100-m">
    <span>{{ startYear }}</span>
    <!-- TODO: The 'tickInterval' property no longer exists -->
    <mat-slider
      id="time-slider"
      step="{{ step }}"
      [min]="startYear"
      [max]="endYear"
      [color]="color"
      thumbLabel
      [disabled]="!enabled() || !layer().visible"
      #ngSlider
      ><input
        matSliderThumb
        [value]="handleSliderValue()"
        (input)="
          handleSliderYearChange({
            source: ngSliderThumb,
            parent: ngSlider,
            value: ngSliderThumb.value
          })
        "
        #ngSliderThumb="matSliderThumb"
        (change)="
          handleSliderYearChange({
            source: ngSliderThumb,
            parent: ngSlider,
            value: ngSliderThumb.value
          })
        "
      />
    </mat-slider>
    <span>{{ endYear }}</span>
    @if (enabled()) {
      <p class="date-below">{{ year }}</p>
    }
    <ng-container *ngTemplateOutlet="layerActions" />
  </div>
}

@if (style === 'slider' && type !== 'year') {
  <div class="igo-col igo-col-100 igo-col-100-m">
    <!-- TODO: The 'tickInterval' property no longer exists -->
    <mat-slider
      id="time-slider"
      [step]="step"
      [min]="dateToNumber(min)"
      [max]="dateToNumber(max)"
      thumbLabel
      [disabled]="!options().enabled || !layer().visible"
      (selectionChange)="handleSliderDateChange($event)"
      #ngSlider
      ><input
        matSliderThumb
        [value]="handleSliderValue()"
        (input)="
          handleSliderDateChange({
            source: ngSliderThumb,
            parent: ngSlider,
            value: ngSliderThumb.value
          })
        "
        #ngSliderThumb="matSliderThumb"
      />
    </mat-slider>
    <p class="date-below">{{ handleSliderTooltip() }}</p>
    <ng-container *ngTemplateOutlet="layerActions" />
  </div>
}

<!-- Reusable Actions Template -->
<ng-template #layerActions>
  <div class="igo-layer-actions-container">
    <mat-slide-toggle
      (change)="toggleFilterState()"
      tooltip-position="below"
      matTooltipShowDelay="500"
      [matTooltip]="'igo.geo.filter.toggleFilterState' | translate"
      [color]="color"
      [checked]="enabled()"
      [disabled]="!layer().visible"
    />
    <button
      [disabled]="!enabled() || !layer().visible"
      mat-icon-button
      color="primary"
      (click)="play()"
    >
      <mat-icon>{{ playIcon }}</mat-icon>
    </button>
    <button
      [disabled]="!enabled() || !layer().visible"
      mat-icon-button
      color="primary"
      (click)="resetFilter()"
      matTooltipShowDelay="500"
      [matTooltip]="'igo.geo.filter.resetFilters' | translate"
    >
      <mat-icon>{{ resetIcon }}</mat-icon>
    </button>
  </div>
</ng-template>
